import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { Provider } from 'mobx-react'
import List from './List'

export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  render() {
    return (
      <Provider store={this.store}>
        <HeaderView title="团队邀请">
          <List />
        </HeaderView>
      </Provider>
    )
  }
}
